import { PageHero } from "../components/site/PageHero";
import { FadeUp, Eyebrow } from "../components/site/Motion";
import { useLang } from "../i18n/LangContext";
import { PRIVACY } from "../i18n/privacy";

export default function Privacy() {
  const { lang } = useLang();
  const p = PRIVACY[lang];
  return (
    <main data-testid="privacy-page">
      <PageHero key={p.lines[0]} testId="privacy-hero" eyebrow={p.eyebrow} lines={p.lines} intro={p.intro} />
      <section className="mx-auto max-w-7xl px-5 pb-24 sm:px-8 lg:pb-32">
        <p className="mb-10 font-mono text-xs uppercase tracking-[0.2em] text-stone-600">{p.updated}</p>
        {p.sections.map((s, i) => (
          <FadeUp key={s.h} className="grid gap-4 border-t border-[#D6CEBF] py-10 lg:grid-cols-12 lg:gap-10">
            <h2 className="font-serif text-3xl text-[#1C1917] lg:col-span-4">
              <span className="mr-3 font-mono text-xs text-[#C85A32]">{String(i + 1).padStart(2, "0")}</span>
              {s.h}
            </h2>
            <div className="space-y-4 text-base leading-relaxed text-stone-700 lg:col-span-8">
              {s.p.map((t) => <p key={t}>{t}</p>)}
            </div>
          </FadeUp>
        ))}
        <FadeUp className="border-t border-[#D6CEBF] pt-10">
          <Eyebrow>{p.storageTitle}</Eyebrow>
          <div className="overflow-x-auto">
            <table data-testid="privacy-storage-table" className="w-full min-w-[560px] text-left text-sm">
              <thead>
                <tr className="border-b border-[#D6CEBF] font-mono text-xs uppercase tracking-[0.15em] text-stone-600">
                  {p.storageHead.map((h) => <th key={h} className="py-3 pr-6 font-normal">{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {p.storage.map((r) => (
                  <tr key={r[0]} className="border-b border-[#E7E2D7] text-stone-700">
                    {r.map((c, j) => <td key={j} className={`py-4 pr-6 ${j === 0 ? "font-mono text-[#1C1917]" : ""}`}>{c}</td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </FadeUp>
      </section>
    </main>
  );
}
